import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Paper } from '@material-ui/core';

import CardTitle from '../../../common/card/CardTitle';
import BoardItem from './BoardItem';
import BoardItemWithSubtask from './BoardItemWithSubtask';

export interface BoardColumnProps {
  title: string;
  droppableId: string;
  tasks?: any[];
  loadingItemId?: number;
}

const BoardColumn: React.FC<BoardColumnProps> = (props: BoardColumnProps) => {
  const { title, droppableId, tasks: tasksProp, loadingItemId } = props;
  const tasks: any[] = tasksProp ? tasksProp.filter((task: any) => !!task) : [];

  return (
    <Paper className='column'>
      <CardTitle>{title}</CardTitle>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div className='card-container' ref={provided.innerRef}>
            {tasks.map((task, index) => {
              const hasSubtask = task.children?.length > 0;
              return (
                <Draggable
                  key={task.id}
                  index={index}
                  draggableId={task.id.toString()}
                >
                  {(provided, snapshot) => {
                    if (hasSubtask) {
                      return (
                        <BoardItemWithSubtask
                          {...{ task, provided, snapshot }}
                          isLoading={loadingItemId === task.id}
                        />
                      );
                    }
                    return (
                      <BoardItem
                        {...{ task, provided, snapshot }}
                        isLoading={loadingItemId === task.id}
                      />
                    );
                  }}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </Paper>
  );
};

export default BoardColumn;
